import { FC, useEffect, useRef } from "react"
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import { openModalSCR$ } from "../../financiamento/Financeiras";

interface TermoAceiteProperties {
    termo: any;
    onChange: (aceite: boolean) => void;
}


const TermoAceite: FC<TermoAceiteProperties> = ({
    termo,
    onChange
}) => {
    const scrModalRef = useRef<any>(null);

    useEffect(() => {
        if (termo) {
            scrModalRef.current = document.getElementById("saiba-mais-flag-src");
        }

    }, [termo])

    useEffect(() => {
        if (scrModalRef.current) {
            scrModalRef.current.addEventListener("click", () => {
                openModalSCR$.next(true);
            })
        }
    }, [scrModalRef]);

    

    return <><div className="TermoAceite">

        <div className="container-termo">
            <div className={`checkbox-container${termo.aceito ? " checked" : ""}`} onClick={() => {
                onChange(!termo.aceito)
            }}>
                {termo.aceito ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />}
            </div>
            <div className="text-termo" dangerouslySetInnerHTML={{ __html: `${termo.opcional ? "[OPCIONAL] " : ""}${termo.texto}` }} />
        </div>
    </div>
    
    </>
}

export { TermoAceite }